import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

const PhoneButton = ({
  LogoSvg,
  phoneNumber,
  logoHeight,
  logoWidth,
  logoColor,
}) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const [opacity, setOpacity] = useState(1);
  let scrollTimeout = null;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      setOpacity(0);

      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
        setOpacity(1);
      }, 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      component="a"
      href={`tel:${phoneNumber}`}
      sx={{
        position: "fixed",
        bottom: "1.5rem",
        right: "1.5rem",
        padding: "0.25rem",
        zIndex: 1000,
        opacity: opacity,
        transition: isScrolling ? "opacity 0s" : "opacity 1s",
      }}
    >
      <LogoSvg height={logoHeight} width={logoWidth} fill={logoColor} />
    </Box>
  );
};

export default PhoneButton;
